import { useQuery } from "@tanstack/react-query";
import { emptyPage, Page, Selector } from "@/model";
import selectorRepository from "@/repository/selectorRepository";


const getData = async (agentId: number, page: number, size: number, keyword?: string, sortKey?: string, sortOrder?: string) => {
    const res = await selectorRepository.find(agentId, page, size, keyword, sortKey, sortOrder);
    return res.data?.data || emptyPage<Selector>();
};

export const usePaginatedSelectors = (agentId: number, page: number, size: number, keyword?: string, sortKey?: string, sortOrder?: string) => {
    return useQuery<Page<Selector>>({
        queryKey: ['page-selector', 'agent', agentId, 'page', page, 'size', size, 'keyword', keyword, 'sortKey', sortKey, 'sortOrder', sortOrder],
        queryFn: async () => getData(agentId, page, size, keyword, sortKey, sortOrder),
        retry: false
    });
};
